module.exports = __webpack_public_path__ + "static/media/3.89a991dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/LastProjects/assets/3.jpg
// module id = 43
// module chunks = 0